<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: "svg-icon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.svg-icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
  stroke: currentColor;
  overflow: hidden;
  vertical-align: -0.35em;
}
.card-title {
  // color: #f5222d;
  color: #8c8c8c;
}
.bid-card-svg {
  width: 16px;
  color: #1677ff;
  vertical-align: middle;
}
.statistics-svg {
  // border: 1px solid #ffa39e;
  padding: 12px 0;
  border-radius: 28px;
  // color: #ff7875;
  // fill: #ff7875;
  width: 56px;
  height: 56px;
}
</style>